<template lang="pug">
  div
    .dashboard
      card(title="Casas Totales" :amount="dashboard.total_houses")
      card(title="Casas Disponibles" :amount="dashboard.houses_available")
      card(title="Ingresos Generados" :amount="dashboard.revenue")
      card(title="Casas Reservadas" :amount="dashboard.houses_sold")
      card(title="Casas Reservadas Online" :amount="dashboard.houses_sold_online")
    .charts
      .firstChart
        h2 Porcentaje de Ingresos
        apexchart(width='450' type='donut' :options='options' :series='options.series' v-if="!isLoading")
      .secondChart
        h2 Cantidad de Ingresos
        apexchart(width='450' type='bar' :options='options2' :series='options2.series2' )

</template>

<script>
// import Card from '../components/aditionals/Card.vue'
import Card from '../../components/aditionals/Card.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'dashboard',
  components: {
    Card
  },

  data () {
    return {
      isLoading: false,
      options: {
        labels: [],
        colors: [],
        series: [],
        chart: {
          toolbar: {
            show: true
          }
        }
      },
      options2: {
        labels: [''],
        colors: ['#3498db', '#2ecc71', '#f1c40f', '#aa00b7'],
        series2: [],
        chart: {
          toolbar: {
            show: true
          }
        }
      },

      series2: []
    }
  },

  methods: {
    ...mapActions([
      'loadDashboard'
    ])
  },
  async created () {
    this.isLoading = true
    await this.loadDashboard()
    this.isLoading = false
    this.options.colors = this.dashboard.new_data.map(category => category.color)
    this.options.labels = this.dashboard.new_data.map(category => category.title)
    this.options.series = this.dashboard.new_data.map(category => category.total)
    this.options2.series2 = this.dashboard.revenues_by_maps
  },
  computed: {
    ...mapGetters([
      'dashboard'
    ]),
    series () {
      return this.dashboard.lots_available
    }
  }
}
</script>

<style lang="scss" scoped>
.dashboard {
  width: 100%;
  height: 20vh;
  padding: 15px 30px;
  display: flex;
}
.charts {
  width: 100%;
  height: 0vh;
}

.firstChart {
  padding: 5%;
  width: 40%;
  float: left;
  margin-left: 10%;
}

.secondChart {
  padding: 5%;
  width: 40%;
  float: left;
}

h2 {
  text-align: center;
  margin-bottom: 5%;
}
</style>
